export default __webpack_public_path__ + "static/media/clone1.c4d73e45.svg";